import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {IPhotoContent} from '../../../models/photo.model';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-landscape',
  templateUrl: './landscape.component.html',
  styleUrls: ['./landscape.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class LandscapeComponent implements OnInit {
    iPhotoContent:  IPhotoContent[] = [];

    constructor(  private titleService: Title) {
    this.titleService.setTitle('Alexander Koenig - Landschaftsaufnahmen');
}

  ngOnInit() {
  }

}
